import * as React from 'react';

import './Beacon.css';

const Beacon: React.FC<React.HTMLProps<HTMLDivElement>> = props => (
  <div className="Beacon" {...props} />
);

export default Beacon;
